<template>
    <div>
        <slot
            :can-edit-accounts="canEditAccounts"
            :account="account"
            :page="page"
        ></slot>

        <div class="columns nomargin">
            <div class="column is-6">
                <p class="account-page-title">Employees</p>
                <article class="tile is-child box transparent">
                    <img
                        v-if="account.logo"
                        :src="account.logo"
                    >
                    <p
                        v-if="account.address"
                        class="account-address"
                    >{{ account.address }}</p>
                    <p
                        v-if="account.city"
                        class="account-address"
                    >{{ account.city }}, {{ account.state }}</p>
                    <p
                        v-if="account.zip"
                        class="account-address"
                    >{{ account.zip }}</p>
                    <a
                        v-if="account.website"
                        href="account.website"
                        class="account-website"
                    >{{
                        account.website
                    }}</a>
                    <div class="scrollbox nopad content-holder">
                        <div
                            v-for="user in account.users"
                            :key="user.id"
                            class="account-employee-panel"
                        >
                            <a
                                :href="route('company.user', { id: user.id })"
                                class="user-profile"
                            >
                                <img :src="user.small_avatar" class="small mrs">
                                <span class="hidden" v-text="user.name"></span>
                            </a>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        account: {
            type: Object,
            required: true,
        },
        canEditAccounts: {
            type: Boolean,
            required: false,
        },
        projects: {
            type: Object,
            required: true,
        },

        canViewContacts: {
            type: Boolean,
            required: true,
        },

        currentPage: {
            type: String,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },
    },

    data () {
        return {
            page: 'home',
        };
    },

    computed: {
        thisContext () {
            return this;
        },

        activeProjects () {
            return _.size(this.projects);
        },

        hasLogo () {
            return _.has(this.account, 'logo');
        },
    },

    methods: {
        onChangePage (page) {
            this.page = page;
        },
    },
};
</script>
